import clsx from 'clsx';
import round from 'lodash/round';
import React, { FC } from 'react';

import './CircularLoader.css';

export enum CircularLoaderType {
  primary = 'primary',
  secondary = 'secondary',
  widget = 'widget',
}

export enum CircularLoaderSize {
  sm = 20,
  md = 40,
  lg = 80,
}

const COLORS = {
  [CircularLoaderType.primary]: '!text-white',
  [CircularLoaderType.secondary]: '!text-green60 monochrome:!text-grey90',
  [CircularLoaderType.widget]: '!text-grey90',
};

const CIRCLE_SIZE = {
  [CircularLoaderType.primary]: CircularLoaderSize.md,
  [CircularLoaderType.secondary]: CircularLoaderSize.lg,
  [CircularLoaderType.widget]: CircularLoaderSize.md,
};

export interface CircularLoaderProps {
  type: CircularLoaderType;
  className?: string;
  customSize?: CircularLoaderSize;
}

const CircularLoader: FC<CircularLoaderProps> = (
  props: CircularLoaderProps
) => {
  const { type, className: classNameCustom, customSize } = props;

  const color = COLORS[type] ?? COLORS[CircularLoaderType.primary];
  const size =
    customSize ?? CIRCLE_SIZE[type] ?? CIRCLE_SIZE[CircularLoaderType.primary];
  const strokeWidth = round(size / 11.4, 1);

  const className = {
    root: `loader-container loader-container--${CircularLoaderSize[size]}`,
    svg: `block ${color}`,
    circle: `inline-block stroke-current loader-circle--${CircularLoaderSize[size]}`,
  };

  return (
    <div className={clsx('flex', classNameCustom)}>
      <span className={className.root} role="progressbar">
        <svg
          className={className.svg}
          viewBox={`${size / 2} ${size / 2} ${size} ${size}`}
        >
          <circle
            className={className.circle}
            cx={size}
            cy={size}
            r={(size - strokeWidth) / 2}
            strokeWidth={strokeWidth}
            fill="none"
          />
        </svg>
      </span>
    </div>
  );
};

export default CircularLoader;
